<template>
  <div class="v-footer">
    <div class="footer-top">
      <div class="bx">
        <!-- <div class="f-col one">
          <dl>
            <dd class="left label-color" style="font-size: 18px; color: #EBEBEB;">{{jsonData.footer.leftTitle}}</dd>
            <dd class="left">
              <dt class="dt-box">
                <img src="../../assets/images/index/smallRoutine.jpg" class="dt-box-img" alt="">
                <label v-show="missionType==''||missionType==null">{{jsonData.footer.scanCode4}}</label>
                <label v-show="missionType!=''&&missionType!=null">{{jsonData.footer.scanCode8}}</label>
              </dt>
              <dt class="dt-box">
                <img src="../../assets/images/index/gongzhong.jpg" class="dt-box-img" alt="">
                <label v-show="missionType==''||missionType==null">{{jsonData.footer.scanCode3}}</label>
                <label v-show="missionType!=''&&missionType!=null">{{jsonData.footer.scanCode7}}</label>
              </dt>
              <dt class="dt-box">
                <img src="../../assets/images/index/shipin.jpg" class="dt-box-img" alt="">
                <label v-show="missionType==''||missionType==null">{{jsonData.footer.scanCode1}}</label>
                <label v-show="missionType!=''&&missionType!=null">{{jsonData.footer.scanCode5}}</label>
              </dt>
              <dt class="dt-box ">
                <img src="../../assets/images/index/douyin.jpg" class="dt-box-img" alt="">
                <label v-show="missionType==''||missionType==null">{{jsonData.footer.scanCode2}}</label>
                <label v-show="missionType!=''&&missionType!=null">{{jsonData.footer.scanCode6}}</label>
              </dt>
            </dd>
          </dl>
        </div> -->

        <div class="f-col">
          <dl class="right">
            <dd class="dd-start">
              <img src="../../assets/images/bottom/gsdz.png" style="width: 14px;height: 14px;margin-right: 5px;" alt="">
              <label class="label-color dt-box-two"> 公司名称：{{jsonData.footer.companyAddress}}</label>
            </dd>
            <dd class="dd-start">
              <img src="../../assets/images/bottom/gajg2.png" style="width: 17px;height: 17px;margin-right: 5px;" alt="">
              <label class="label-color dt-box-two">备案编号：<a href="https://beian.miit.gov.cn" target="_Blank">{{jsonData.footer.icp}}</a></label>
            </dd>
            <dd class="dd-start ">
              <img src="../../assets/images/bottom/dzxx.png" style="width: 14px;height: 14px;margin-right: 5px;" alt="">
              <label class="label-color dt-box-two" style="vertical-align:top;">企业地址：{{jsonData.footer.Alladdress}}</label>
            </dd>
            <!-- <dd class="dd-start ">
              <img src="../../assets/images/bottom/gajg2.png" style="width: 17px;height: 17px;margin-right: 5px;margin-bottom: 3px" alt="">
              <label class="label-color dt-box-two">闽公网安备 35018202000223号</label>
            </dd> -->
          </dl>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import JSON from "../../assets/decent_index.js"
  export default {
    name: 'v-footer',
    data() {
      return {
        jsonData: JSON,
        msg: 'Welcome to Your Vue.js App',
        missionType:null
      }
    },
    created(){
      this._isMobile();
    },
    methods:{
      _isMobile() {
        this.missionType = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .v-footer {
    background: #268DFF;
    color: #999;
    font-size: 13px;
    color: #EBEBEB;
    font-family: 'SimHei', '黑体' !important;
    font-weight: 100;
    padding: 10px 20px 10px 20px;

    .label-color {
      opacity: .9;
      color: #EBEBEB;
      font-family: 'SimHei', '黑体' !important;
      font-weight: 100;
    }

    a {
      color: #999;
    }

    .footer-top {
      // padding: 10px 0;


      dl {
        dt {
          font-size: 18px;
          color: #fff;
          border-bottom: 1px solid #999;
        }

        .dd-start-padding {
          // padding-top: 10px;
        }

        dd {

          line-height: 25px;
          color: #CED4DA;

          .dt-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 6px;

            @media screen and(max-width: 320px) {
              margin: 0 4px;
            }

            .dt-box-img {
              width: 98px;
              height: 98px;
              margin: 5px;

              @media screen and (max-width: 830px) {
                width: 68px !important;
                height: auto;
                // background-color: yellow;
              }
            }

            label {
              font-size: 12px;
              line-height: 20px;
              color: #EBEBEB;
              font-family: 'SimHei', '黑体' !important;
              opacity: .9;
              font-weight: 100;
            }
          }
        }

        .left {
          display: flex;
          justify-content: center;
          margin: 10px 0;

        }
      }

      .f-col {
        dt {
          margin-bottom: 0;
          border: none;
        }
      }

      .f-col {
        dl {
          dt {
            font-size: 15px;
          }
        }
      }
    }

    .footer-top>div {
      display: flex;
      -webkit-display: flex;
      -moz-display: flex;
      -o-display: flex;

      .f-col {
        flex: 1;
        align-items: center;
        // justify-content: space-evenly;
        display: flex;
        // flex-basis:25%;
        flex-basis: 15%;

        .right {
          display: flex;
          flex-wrap: wrap;
          overflow: hidden;
            width: 100%;
            justify-content:space-around;

          @media screen and(max-width: 2000px) {
            width: 100%;
            justify-content:space-around;

          }
          @media screen and(max-width: 1200px) {
            justify-content:space-around;
          }
          @media screen and(max-width: 700px) {
            width: 90%;
            justify-content:space-between
          }

          @media screen and(max-width:539px) {
            width: 70%;
          }

          @media screen and(max-width:541px) {
            width: 90%;
          }

          .dd-start {
            // float: left;
            // display: block;
            text-align: left;
            // margin-left: 220px;
            a{
              text-decoration:none;
              color: #EBEBEB;
            }
            @media screen and(max-width: 2000px) {
              margin-left: 0;
            }
            @media screen and(max-width: 1620px) {
              margin-left: 0;
              // height: 50px;
            }
            @media screen and(max-width: 1200px) {
              margin-left: 0;
            }
             @media screen and(max-width: 541px) {
              width:auto;
              justify-content:space-between
            }
          }
        }
      }

      .f-col.one {
        // flex:2;
        flex-basis: 20%;

        img {
          width: auto;
          height: auto;
        }
      }

      // 小于820px换行，100%宽
      @media screen and (max-width:830px) {
        flex-wrap: wrap;
        // justify-content:center;
        font-size: 16px;

        .f-col {
          // padding-top:0px;
          flex-basis: 100%;

          dl {
            margin: 0 auto;

            .dd-start {
              display: flex;

              // justify-content: flex-start;
              // align-items: center;
              img {
                margin-top: 5px;
              }

              .dt-box-two {
                font-size: 12px;
                text-align: left;
                a{
                  text-decoration:none;
                  color: #EBEBEB;
                }
              }
            }
          }
        }
      }

      .have-line {
        position: relative;

        &:after {
          content: '';
          display: block;
          height: 1px;
          background-color: #2d2d2d;
          margin-top: 12px;
        }
      }
    }

    // 底部
    .footer-bot {
      background: #000;
      width: 100%;

      &>div.bx {
        padding: 0 22px;
        // display: flex;
        // -webkit-display: flex;
        // -moz-display: flex;
        // -o-display: flex;
        // justify-content: space-between;
        // align-items: center;

        .f-right {
          display: flex;
          -webkit-display: flex;
          -moz-display: flex;
          -o-display: flex;

          div {
            margin: 0 6px;
          }
        }

        @media screen and (max-width:768px) {
          flex-wrap: wrap;
          padding: 10px;

          &>div {
            margin: 0 auto;
          }
        }
      }
    }

  }
</style>
